import {Utilities} from '../../shared/utilities/utilities.model';
import { TagItemSettings } from '@shared/models/tag-item.model';
/**
 * Created by wladimir on 17/04/18.
 */

export class ThreadItemList {
	thread_id: string;
	alert_ids: string[];
	created_at: string;
	created_by: string;
	updated_at: string;
	updated_by: string;
	user_ids: string[];
	readers: string[];
	module: string;
	commodity_id: string;
	ald_commodity_id: string;
	ald_order_id: string;
	subject: string;
	text: string;
	metadata: Map<string, string>;
	flags: string[];
	tags: TagItemSettings[];
	is_read: boolean;
	alert_count: number;
	attachment_count: number;
	checked: boolean;

	constructor(model?: any) {
		this.checked = false;
		this.metadata = new Map<string, string>();
		if (model) {
			this.thread_id = model.thread_id;
			this.alert_ids = [];
			if (!Utilities.isVoid(model.alert_ids)) {
				for (let i = 0; i < model.alert_ids.length; i++) {
					this.alert_ids.push(model.alert_ids[i]);
				}
			}
			this.created_at = model.created_at;
			this.created_by = model.created_by;
			this.updated_at = model.updated_at;
			this.updated_by = model.updated_by;
			this.user_ids = [];
			if (!Utilities.isVoid(model.user_ids)) {
				for (let i = 0; i < model.user_ids.length; i++) {
					this.user_ids.push(model.user_ids[i]);
				}
			}
			this.readers = [];
			if (!Utilities.isVoid(model.readers)) {
				for (let i = 0; i < model.readers.length; i++) {
					this.readers.push(model.readers[i]);
				}
			}
			this.module = model.module;
			this.commodity_id = model.commodity_id;
			this.ald_commodity_id = model.ald_commodity_id;
			this.ald_order_id = model.ald_order_id;
			this.subject = model.subject;
			this.text = model.text;
			if (!Utilities.isVoid(model.metadata)) {
				const keys = Object.keys(model.metadata);
				for (const key of keys) {
					this.metadata.set(key, model.metadata[key]);
				}
			}
			this.flags = [];
			if (!Utilities.isVoid(model.flags)) {
				for (let i = 0; i < model.flags.length; i++) {
					this.flags.push(model.flags[i]);
				}
			}
			this.tags = [];
			if (!Utilities.isVoid(model.tags)) {
				this.tags = model.tags;
			}
			this.is_read = model.is_read;
			this.alert_count = model.alert_count;
			this.attachment_count = model.attachment_count;
		}

	}
}

